import { Injectable } from "@angular/core";

import { html } from "@codemirror/lang-html";
import { LanguageDescription, LanguageSupport } from "@codemirror/language";


@Injectable()
export class HtmlEditorLanguageService {

    public getLanguageDescription(): LanguageDescription {
        const language: LanguageSupport = html();

        return LanguageDescription.of({ name: language.language.name, support: language })
    }
}